// removed by extract-text-webpack-plugin
module.exports = {"Wrap":"_2knTVDvbai30y_N6k52xpS","Checkbox":"_1_ogQIhg5bJp8AKP7p_urI","Icon":"Ml2Ar_7Q8bd9t7aUbwYVJ"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Utils/UI/StatusCheckbox/styles.module.css
// module id = 600
// module chunks = 0